import { VehicleCarouselSection } from './VehicleCarouselSection';

interface VehicleDetailRelatedProps {
  vehicles: any[];
}

export function VehicleDetailRelated({ vehicles }: VehicleDetailRelatedProps) {
  if (!vehicles.length) return null;

  return (
    <div className="wl6-vd-related">
      <VehicleCarouselSection
        title="Veículos relacionados"
        viewAllHref="/estoque"
        viewAllLabel="Ver estoque"
        vehicles={vehicles}
        showViewAll
      />
    </div>
  );
}
